import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import CurrencyInput from '../../common/currencyInput';
import CheckboxSwitch from '../../common/checkboxSwitch';
import PercentageInput from '../../common/percentageInput';
import { SHOP_TYPE } from './constants';
import Icon, { GLYPHS } from '../../common/icon';

const renderFees = currency => (
  <div>
    <div className="layout__item">
      <div className="c-label-new">Card Not Present Flat Fee</div>
      <CurrencyInput
        className="c-input"
        placeholder="Card Not Present Flat Fee"
        name="creditCardFlatFee"
        currency={currency}
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">Card Not Present % Fee
      </div>
      <PercentageInput
        className="c-input"
        placeholder="Card Not Present % Fee"
        name="creditCardPercentFee"
        currency={currency}
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">Amex Card Not Present Flat Fee</div>
      <CurrencyInput
        className="c-input"
        placeholder="Amex Card Not Present Flat Fee"
        name="amexCreditCardFlatFee"
        currency={currency}
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">Amex Card Not Present % Fee</div>
      <PercentageInput
        className="c-input"
        placeholder="Amex Card Not Present % Fee"
        name="amexCreditCardPercentFee"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">Card Present Flat Fee</div>
      <CurrencyInput
        className="c-input"
        placeholder="Card Present Flat Fee"
        name="presentCreditCardFlatFee"
        currency={currency}
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">Card Present % Fee
      </div>
      <PercentageInput
        className="c-input"
        placeholder="Card Present % Fee"
        name="presentCreditCardPercentFee"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">Amex Card Present Flat Fee</div>
      <CurrencyInput
        className="c-input"
        placeholder="Amex Card Present Flat Fee"
        name="amexPresentCreditCardFlatFee"
        currency={currency}
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">Amex Card Present % Fee
      </div>
      <PercentageInput
        className="c-input"
        placeholder="Amex Card Present % Fee"
        name="amexPresentCreditCardPercentFee"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new">TapToPay Flat Fee</div>
      <CurrencyInput
        className="c-input"
        placeholder="TapToPay Flat Fee"
        name="tapToPayFlatFee"
        currency={currency}
      />
    </div>
  </div>
);

const FeesForm = ({
  currency,
  customerBookingFeeLimitEnabled,
  creditCardFeeEnabled,
  boothRentalEnabled,
  isRental,
}) => (
  <div>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">
      Fees
    </div>
    <div className="c-wrapper-horizontal">
      <div className="layout">
        <CheckboxSwitch
          name="customerBookingFeeLimitEnabled"
          id="customerBookingFeeLimitEnabled"
          label="Rolling Squire Fees"
          wrapperClass="layout__item"
        />
        <CheckboxSwitch
          display-if={customerBookingFeeLimitEnabled}
          name="legacyCustomerBookingFeeCalculation"
          id="legacyCustomerBookingFeeCalculation"
          label="Use Legacy Calculation"
          wrapperClass="layout__item"
        />
        <div className="layout__item" display-if={!customerBookingFeeLimitEnabled}>
          <div className="c-label-new">Client Booking Fee</div>
          <CurrencyInput
            className="c-input"
            placeholder="Client Booking Fee"
            name="customerBookingFee"
            currency={currency}
          />
        </div>
        <div className="layout__item">
          <div className="c-label-new">Waiting list fee</div>
          <CurrencyInput
            className="c-input"
            placeholder="Waiting list fee"
            name="waitingListFee"
            currency={currency}
          />
        </div>
        <div className="layout__item" display-if={customerBookingFeeLimitEnabled}>
          <div className="c-label-new">1st Tier Value ($1 fee)</div>
          <CurrencyInput
            className="c-input"
            placeholder="1st Tier Value ($1 fee)"
            name="customerBookingFeeBottomLimit"
            currency={currency}
          />
        </div>
        <div className="layout__item" display-if={customerBookingFeeLimitEnabled}>
          <div className="c-label-new">2nd Tier Value ($3 fee)</div>
          <CurrencyInput
            className="c-input"
            placeholder="2nd Tier Value ($3 fee)"
            name="customerBookingFeeTopLimit"
            currency={currency}
          />
        </div>
        <CheckboxSwitch
          name="creditCardFeeEnabled"
          id="creditCardFeeEnabled"
          label="Credit Card Fee Enabled"
          wrapperClass="layout__item"
        />
        {creditCardFeeEnabled && renderFees(currency)}
        <div className="layout__item">
          <div className="c-label-new">Rapid Transfer Percentage Fee</div>
          <PercentageInput
            className="c-input"
            placeholder="Rapid Transfer Percentage Fee"
            name="instantPayoutPercentageFee"
          />
        </div>
        <div className="layout__item c-heading--dark" display-if={!isRental}>
          <Icon glyph={GLYPHS.warning} />
          <span className="u-type--bold u-ml--">WARNING:</span>
          <span> Only enable Rent Collect option for shops included in Hybrid Alpha cohort, and having corresponding Launch Darkly flag enabled</span>
        </div>
        <CheckboxSwitch
          name="boothRentalEnabled"
          id="boothRentalEnabled"
          label="Rent Collect"
          wrapperClass="layout__item"
        />
        <div className="layout__item" display-if={boothRentalEnabled}>
          <div className="c-label-new">Rent Collect Fee</div>
          <PercentageInput
            className="c-input"
            placeholder="Rent Collect Fee"
            name="boothRentalFee"
          />
        </div>
      </div>
    </div>
  </div>
);

FeesForm.propTypes = {
  currency: PropTypes.string.isRequired,
  creditCardFeeEnabled: PropTypes.bool.isRequired,
  customerBookingFeeLimitEnabled: PropTypes.bool.isRequired,
  boothRentalEnabled: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('editShop');

  return {
    boothRentalEnabled: selector(state, 'boothRentalEnabled'),
    creditCardFeeEnabled: selector(state, 'creditCardFeeEnabled'),
    customerBookingFeeLimitEnabled: selector(state, 'customerBookingFeeLimitEnabled'),
    isRental: parseInt(selector(state, 'kind'), 10) === SHOP_TYPE.rental,
  };
};

export default connect(mapStateToProps)(FeesForm);
